import React from "react";
import { useNavigate } from "react-router-dom";
import "./Banner.css";

const Banner = () => {
  const navigate = useNavigate();

  return (
    <section className="cta5" aria-labelledby="cta5-heading">
      <div className="cta5-wrap">
        <div className="cta5-main">
          <div className="cta5-copy">
            <p className="cta5-kicker">One call, one plan</p>

            <h2 id="cta5-heading" className="cta5-title">
              Get a clear plan for your <span>website, leads and marketing</span>
            </h2>

            <p className="cta5-sub">
              We review your setup, spot the biggest wins, and give you a focused 7–14 day action plan with concrete next steps.
            </p>

            <div className="cta5-actions">
              <button
                className="cta5-btn cta5-btnPrimary"
                type="button"
                onClick={() => navigate("/contact")}
              >
                Book a free plan call
              </button>

              <button
                className="cta5-btn cta5-btnOutline"
                type="button"
                onClick={() => navigate("/services")}
              >
                See services
              </button>
            </div>
          </div>

          <aside className="cta5-side" aria-label="What you get">
            <p className="cta5-sideLabel">What you get</p>
            <p className="cta5-sideSub">A focused review and a practical plan you can start using right away.</p>

            <div className="cta5-list">
              <div className="cta5-li">
                <span className="cta5-bullet" />
                <div>
                  <div className="cta5-liTitle">Top 3 fixes</div>
                  <div className="cta5-liText">Highest-impact improvements first</div>
                </div>
              </div>

              <div className="cta5-li">
                <span className="cta5-bullet" />
                <div>
                  <div className="cta5-liTitle">Funnel clarity</div>
                  <div className="cta5-liText">Clear changes for pages and CTAs</div>
                </div>
              </div>

              <div className="cta5-li">
                <span className="cta5-bullet" />
                <div>
                  <div className="cta5-liTitle">Tracking checklist</div>
                  <div className="cta5-liText">Know what's working and what isn't</div>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default Banner;
